// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__N36ka","BasicHeader":"Header_BasicHeader__Pb+KO","PatientInfo":"Header_PatientInfo__7TdTP"};